import { render, staticRenderFns } from "./v-inline-notifications.vue?vue&type=template&id=526ce966&"
import script from "./v-inline-notifications.vue?vue&type=script&lang=js&"
export * from "./v-inline-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports